module.exports = "<!-- main app container -->\r\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\r\n<meta http-equiv=\"X-UA-Compatible\" content=\"IE=11\" />\r\n<app-header></app-header>\r\n<router-outlet (activate)=\"onRouterOutletActivate($event)\"></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main